{
  "sdk-download-android": "Λήψη για Android",
  "sdk-connect": "Συνδεθείτε",
  "sdk-download-ios": "Λήψη για iOS",
  "sdk-install": "Εγκατάσταση",
  "sdk-modal-instruct-1": "1. Ανοίξτε την εφαρμογή Binance",
  "sdk-modal-instruct-2": "2. Πατήστε {{icon}} στην αρχική οθόνη",
  "sdk-modal-title": "Συνδεθείτε με την Binance",
  "sdk-no-app": "Δεν έχετε ακόμα την εφαρμογή Binance;"
}